module.exports = __webpack_public_path__ + "media/img/frontend_application/nav-logo-d90d730d074863bcf7871f149c456da5.png";